import { gql } from '@apollo/client';

export const FETCH_LEVEL_LOCATIONS = gql`
  query FetchLevelLocationsV2(
    $division: UUIDInput!
    $level: Int!
    $location: UUIDInput!
    $parentLocation: UUIDInput!
  ) {
    findLocationsDependencyLevel(
      division: $division
      level: $level
      location: $location
      parentLocation: $parentLocation
    ) {
      division {
        uuid
        name
      }
      level
      location {
        uuid
        locationName
        locationType
      }
      locationAux {
        uuid
        locationName
        locationType
      }
      unselectedLocations {
        uuid
        locationName
        locationType
      }
    }
  }
`;

export const CREATE_LEVEL_DEPENDENCY_MATRIX = gql`
  mutation CreateDependencyMatrix($input: CreateLocationDependencyInput!) {
    createLocationDependencyTree(input: $input) {
      location {
        capacity
        capacityUnit
        city
        country
        employeeCount
        locationAddress
        locationName
        locationType
        rebuildCost
        rebuildTime
        state
        street
        uuid
        zipCode
      }
      locationAux {
        capacity
        capacityUnit
        city
        country
        employeeCount
        locationAddress
        locationName
        locationType
        rebuildCost
        rebuildTime
        state
        street
        uuid
        zipCode
      }
      percentage
      supportedRevenue
      uuid
    }
  }
`;

export const FETCH_LEVEL_DEPENDENCY_MATRIX = gql`
  query GetMapping(
    $division: UUIDInput!
    $level: Int!
    $location: UUIDInput!
    $parentLocation: UUIDInput!
  ) {
    findDivisionDependencyMatrix(
      division: $division
      level: $level
      location: $location
      parentLocation: $parentLocation
    ) {
      division {
        __typename
        key: uuid
        name
        locationAuxs {
          key: uuid
          name
          percentage
          supportedRevenue
          comment
          locationType
        }
        revenue: supportedRevenue
        children: productGroups {
          __typename
          key: uuid
          name
          locationAuxs {
            key: uuid
            name
            percentage
            supportedRevenue
            comment
            locationType
          }
          revenue: supportedRevenue
          children: products {
            __typename
            key: uuid
            name
            locationAuxs {
              key: uuid
              name
              percentage
              supportedRevenue
              comment
              locationType
            }
            revenue: supportedRevenue
          }
        }
      }
    }
  }
`;

export const UPDATE_DIVISION_LEVEL_PERCENTAGE = gql`
  mutation updateLevelPercentage(
    $data: UpdateLocationDependencyDivisionInput!
  ) {
    updateLocationAuxDivisionPercentage(input: $data) {
      location {
        uuid
        locationName
      }
      locationAux {
        uuid
        locationName
      }
      percentage
      supportedRevenue
      uuid
    }
  }
`;

export const UPDATE_PRODUCT_GROUP_LEVEL_PERCENTAGE = gql`
  mutation updateLevelPercentage(
    $data: UpdateLocationDependencyProductGroupInput!
  ) {
    updateLocationAuxProductGroupPercentage(input: $data) {
      location {
        uuid
        locationName
      }
      locationAux {
        uuid
        locationName
      }
      percentage
      supportedRevenue
      uuid
    }
  }
`;

export const UPDATE_PRODUCT_LEVEL_PERCENTAGE = gql`
  mutation updateLevelPercentage($data: UpdateLocationDependecyProductInput!) {
    updateLocationAuxProductPercentage(input: $data) {
      location {
        uuid
        locationName
      }
      locationAux {
        uuid
        locationName
      }
      percentage
      supportedRevenue
      uuid
    }
  }
`;

export const EDIT_LOCATION_LEVEL_COMMENT = gql`
  mutation updateDependencyComment(
    $input: UpdateLocationDependencyDivisionInput!
  ) {
    updateDependencyComment(input: $input) {
      uuid
    }
  }
`;
